/** Situações de Contatos */
export interface PessoaContatoSituacao {
    id: number;
    nome: string;
    iconClass: string;
    badge: string;
}

export const contatoSituacaoAtivo: PessoaContatoSituacao = {
    id: 1,
    nome: 'Ativo',
    iconClass: 'fas fa-phone',
    badge: 'badge badge-success'
};
export const contatoSituacaoInativo: PessoaContatoSituacao = {
    id: 2,
    nome: 'Inativo',
    iconClass: 'fas fa-phone-slash',
    badge: 'badge badge-danger'
};

export const contatoSituacoes: PessoaContatoSituacao[] = [
    contatoSituacaoAtivo,
    contatoSituacaoInativo
];

/** Verifica se a situação do contato é Ativo */
export function isContatoSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === contatoSituacaoAtivo.id;
}

/** Verifica se a situação do contato é Inativo */
export function isContatoSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === contatoSituacaoInativo.id;
}
